import useCRMStore from '../../store/useCRMStore'

/**
 * Banner pill que muestra el conteo de contactos nuevos pendientes de mostrar.
 * Se renderiza cuando `pendingNew.length > 0`. Click llama al onClick prop
 * (que en TodoListView descongela el frozen mode y recarga la grilla).
 *
 * Estilo: pill verde esmeralda con flecha hacia arriba para sugerir
 * "scrollea al top y mira los nuevos". Tooltip explicativo.
 *
 * Introducido 2026-05-04 (INC-034) como reemplazo del auto-prepend que provocaba
 * drift de scroll por compensacion preemptiva en useScrollAnchor.
 */
export default function PendingNewPill({ onClick }) {
  const count = useCRMStore(s => s.pendingNew.length)
  if (count === 0) return null

  const label = count === 1 ? '1 nuevo' : `${count} nuevos`
  const titleText = count === 1
    ? 'Hay 1 contacto nuevo esperando ser mostrado. Click para verlo.'
    : `Hay ${count} contactos nuevos esperando ser mostrados. Click para verlos.`

  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border bg-emerald-100 dark:bg-emerald-900/30 border-emerald-400 dark:border-emerald-700 text-emerald-900 dark:text-emerald-200 hover:bg-emerald-200 dark:hover:bg-emerald-800/40 transition-colors shadow-sm"
      title={titleText}
    >
      <span aria-hidden="true">{'\u{2191}'}</span>
      <span>{label}</span>
      <span className="font-semibold">· mostrar</span>
    </button>
  )
}
